"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentRepository = void 0;
/**
 * https://seismic.atlassian.net/wiki/spaces/UP/pages/3387916486/Repositories
 */
var ContentRepository;
(function (ContentRepository) {
    ContentRepository["Unknown"] = "Unknown";
    ContentRepository["ContentManager"] = "ContentManager";
    ContentRepository["Channels"] = "Channels";
    ContentRepository["Learning"] = "Learning";
    ContentRepository["LiveDoc"] = "LiveDoc";
    ContentRepository["LiveSocial"] = "LiveSocial";
    ContentRepository["Meetings"] = "Meetings";
    ContentRepository["Practice"] = "Practice";
    ContentRepository["Workspace"] = "Workspace";
})(ContentRepository || (exports.ContentRepository = ContentRepository = {}));
